import { useMemo } from "react";
import { useProfileContext } from "../../../context/ProfileContext";

const WordImage = () => {
  const { currentWord } = useProfileContext();
  const imageURL = useMemo(() => {
    if (currentWord && currentWord.image) {
      return URL.createObjectURL(currentWord.image);
    }
    return null;
  }, [currentWord]);

  const handleImageLoad = () => {
    if (imageURL) {
      URL.revokeObjectURL(imageURL);
    }
  };

  return (
    <div className="relative flex justify-center">
      <img
        src={imageURL ?? ""}
        onLoad={handleImageLoad}
        alt={currentWord?.english}
        width={120}
        height={120}
        className="object-contain"
      />
    </div>
  );
};

export default WordImage;
